import type { Easing, Variants } from 'framer-motion';

export const timings = {
  fast: 0.3,
  medium: 0.6,
  slow: 0.9,
  extraSlow: 1.2,
};

export const easings: Record<'smooth' | 'bounce' | 'elastic', Easing> = {
  smooth: [0.43, 0.13, 0.23, 0.96],
  bounce: [0.43, 0.23, 0.23, 1.12],
  elastic: [0.68, -0.6, 0.32, 1.6],
};

export const pageTransitionVariants: Variants = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
    transition: {
      duration: timings.medium,
      ease: easings.smooth,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      duration: timings.fast,
      ease: easings.smooth,
    },
  },
};

export const hoverVariants: Variants = {
  idle: {
    scale: 1,
    transition: {
      duration: timings.fast,
      ease: easings.smooth,
    },
  },
  hover: {
    scale: 1.05,
    transition: {
      duration: timings.fast,
      ease: easings.smooth,
    },
  },
  tap: {
    scale: 0.95,
    transition: {
      duration: timings.fast,
      ease: easings.smooth,
    },
  },
};
